import React, { useCallback, useEffect, useState } from "react"
import ReboqueForm from "./ReboqueForm"
import { reboquesApi, erroDe, ordemTxt, resumoEixos, rotuloReboque } from "../utils/reboques"

const dh = (v: any) => (v ? new Date(v).toLocaleString("pt-BR", { timeZone: "America/Belem", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—")

// secao "Reboques atrelados" do cavalo (ate o limite do servidor, hoje 2): atrelar, desatrelar, ordem 1o/2o, cadastrar na hora e historico.
// ativoId = null: o cavalo ainda nao foi salvo; a escolha fica em `pendentes` (o pai atrela depois de salvar).
export default function ReboquesAtrelados({ ativoId, clienteId, podeAtrelar = true, podeCadastrar = false, pendentes, setPendentes, onMudou }:
  { ativoId: string | null; clienteId?: string; podeAtrelar?: boolean; podeCadastrar?: boolean; pendentes?: any[]; setPendentes?: (l: any[]) => void; onMudou?: () => void }) {
  const [limite, setLimite] = useState(2)
  const [atrelados, setAtrelados] = useState<any[]>([])
  const [livres, setLivres] = useState<any[]>([])
  const [escolha, setEscolha] = useState("")
  const [erro, setErro] = useState("")
  const [ocupado, setOcupado] = useState(false)
  const [form, setForm] = useState<{ reboque: any | null } | null>(null)
  const [hist, setHist] = useState<any[] | null>(null)
  const lista = ativoId ? atrelados : (pendentes || [])

  const carregar = useCallback(async () => {
    try {
      const [l, a] = await Promise.all([reboquesApi.listar(clienteId, true), ativoId ? reboquesApi.atrelados(ativoId, clienteId) : Promise.resolve(null)])
      setLivres(l)
      if (a) { setAtrelados(a.atrelados); setLimite(a.limite) }
      setErro("")
    } catch (e: any) { setErro(erroDe(e, "Não foi possível carregar os reboques.")) }
  }, [ativoId, clienteId])
  useEffect(() => { carregar() }, [carregar])

  const aplicar = async (novaLista: any[]) => {
    setErro("")
    if (!ativoId) { setPendentes?.(novaLista); return }
    setOcupado(true)
    try {
      const r = await reboquesApi.atrelar(ativoId, novaLista.map((x) => x.id), clienteId)
      setAtrelados(r.atrelados); setLimite(r.limite); setHist(null)
      setLivres(await reboquesApi.listar(clienteId, true)); onMudou?.()
    } catch (e: any) { setErro(erroDe(e, "Não foi possível atualizar os reboques.")) } finally { setOcupado(false) }
  }
  const disponiveis = livres.filter((r) => !lista.some((x: any) => x.id === r.id))
  const atrelar = async (rb: any) => { if (!rb || lista.length >= limite) return; setEscolha(""); await aplicar([...lista, rb]) }
  const desatrelar = async (rb: any) => { if (!window.confirm(`Desatrelar o reboque ${rb.placa}? O histórico fica guardado e os pneus continuam no reboque.`)) return; await aplicar(lista.filter((x: any) => x.id !== rb.id)) }
  const mover = async (i: number, d: -1 | 1) => { const l = [...lista]; const j = i + d; if (j < 0 || j >= l.length) return; [l[i], l[j]] = [l[j], l[i]]; await aplicar(l) }
  const editar = async (rb: any) => { try { const todos = await reboquesApi.listar(clienteId); setForm({ reboque: todos.find((x) => x.id === rb.id) || rb }) } catch (e: any) { setErro(erroDe(e, "Não foi possível abrir o reboque.")) } }
  const verHistorico = async () => { if (hist) { setHist(null); return } try { setHist(await reboquesApi.historico(ativoId!, clienteId)) } catch (e: any) { setErro(erroDe(e, "Não foi possível carregar o histórico.")) } }

  return (
    <section aria-label="Reboques atrelados" style={{ border: "1px solid #2d4166", borderRadius: 12, padding: 14, marginTop: 14 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, gap: 8, flexWrap: "wrap" }}>
        <h4 style={{ margin: 0, fontSize: 14 }}>Reboques atrelados <span style={{ fontWeight: 400, color: "#94a3b8" }}>({lista.length} de {limite})</span></h4>
        {ativoId && <button type="button" className="btn btn-ghost" style={{ padding: "4px 10px", fontSize: 12 }} onClick={verHistorico}>{hist ? "Ocultar histórico" : "Ver histórico"}</button>}
      </div>
      {!ativoId && <p style={{ margin: "0 0 8px", fontSize: 12, color: "#94a3b8" }}>Os reboques escolhidos serão atrelados quando você salvar o veículo.</p>}
      {lista.length === 0 && <p style={{ margin: "0 0 8px", fontSize: 13, color: "#94a3b8" }}>Nenhum reboque atrelado.</p>}
      {lista.map((rb: any, i: number) => (
        <div key={rb.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 0", borderTop: i ? "1px solid #2d4166" : "none", flexWrap: "wrap" }}>
          <b style={{ minWidth: 86, fontSize: 13 }}>{ordemTxt(i + 1)}</b>
          <span style={{ flex: 1, fontSize: 13 }}>{rotuloReboque(rb)} <span style={{ color: "#94a3b8" }}>· {resumoEixos(rb)}</span></span>
          {podeAtrelar && <>
            <button type="button" className="btn btn-ghost" style={{ padding: "2px 8px" }} aria-label={`Subir ${rb.placa}`} disabled={ocupado || i === 0} onClick={() => mover(i, -1)}>▲</button>
            <button type="button" className="btn btn-ghost" style={{ padding: "2px 8px" }} aria-label={`Descer ${rb.placa}`} disabled={ocupado || i === lista.length - 1} onClick={() => mover(i, 1)}>▼</button>
          </>}
          {podeCadastrar && <button type="button" className="btn btn-ghost" style={{ padding: "2px 10px", fontSize: 12 }} onClick={() => editar(rb)}>Editar</button>}
          {podeAtrelar && <button type="button" className="btn btn-ghost" style={{ padding: "2px 10px", fontSize: 12, color: "#f87171" }} disabled={ocupado} onClick={() => desatrelar(rb)}>Desatrelar</button>}
        </div>
      ))}
      {podeAtrelar && lista.length < limite && (
        <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
          <select aria-label="Atrelar reboque" value={escolha} disabled={ocupado} onChange={(e) => { setEscolha(e.target.value); atrelar(disponiveis.find((r) => r.id === e.target.value)) }} style={{ flex: 1, minWidth: 220 }}>
            <option value="">{disponiveis.length ? "— Atrelar um reboque da empresa —" : "Nenhum reboque livre"}</option>
            {disponiveis.map((r) => <option key={r.id} value={r.id}>{rotuloReboque(r)} · {resumoEixos(r)}</option>)}
          </select>
          {podeCadastrar && <button type="button" className="btn btn-ghost" onClick={() => setForm({ reboque: null })}>+ Cadastrar reboque</button>}
        </div>
      )}
      {lista.length >= limite && <p style={{ margin: "8px 0 0", fontSize: 12, color: "#94a3b8" }}>Limite de {limite} reboque(s) por veículo atingido.</p>}
      {erro && <p role="alert" style={{ color: "#f87171", fontSize: 13, margin: "8px 0 0" }}>{erro}</p>}
      {hist && (
        <div style={{ marginTop: 10, overflowX: "auto" }}>
          {hist.length === 0 ? <p style={{ fontSize: 13, color: "#94a3b8" }}>Sem histórico ainda.</p> : (
            <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse" }}>
              <thead><tr style={{ textAlign: "left", color: "#94a3b8" }}><th>Reboque</th><th>Posição</th><th>Atrelado em</th><th>Por</th><th>Desatrelado em</th><th>Por</th></tr></thead>
              <tbody>{hist.map((h) => <tr key={h.id}><td>{h.reboque_placa}</td><td>{ordemTxt(h.ordem)}</td><td>{dh(h.vinculado_em)}</td><td>{h.vinculado_por || "—"}</td><td>{h.desvinculado_em ? dh(h.desvinculado_em) : "Atrelado agora"}</td><td>{h.desvinculado_por || "—"}</td></tr>)}</tbody>
            </table>
          )}
        </div>
      )}
      {form && <ReboqueForm reboque={form.reboque} clienteId={clienteId} podeExcluir={podeCadastrar}
        onFechar={() => setForm(null)}
        onExcluido={async () => { setForm(null); await aplicar(lista.filter((x: any) => x.id !== form.reboque?.id)); await carregar() }}
        onSalvo={async (r) => {
          const editou = !!form.reboque; setForm(null)
          await carregar()
          if (!editou && podeAtrelar && lista.length < limite) await atrelar(r)
          else if (editou) { onMudou?.(); if (ativoId) await carregar() }
        }} />}
    </section>
  )
}
